let workerConfigured = false;

/**
 * @returns {Promise<typeof import('pdfjs-dist/build/pdf.min.mjs')>}
 */
export async function loadPdfJs() {
    const pdfjsLib = await import('pdfjs-dist/build/pdf.min.mjs');

    if (typeof window !== 'undefined' && !workerConfigured) {
        const ver = pdfjsLib.version || '4.10.38';
        pdfjsLib.GlobalWorkerOptions.workerSrc = `https://unpkg.com/pdfjs-dist@${ver}/build/pdf.worker.min.mjs`;
        workerConfigured = true;
    }

    return pdfjsLib;
}

/**
 * @param {Blob} blob
 * @returns {Promise<import('pdfjs-dist').PDFDocumentProxy>}
 */
export async function loadPdfDocumentFromBlob(blob) {
    const pdfjsLib = await loadPdfJs();
    const data = await blob.arrayBuffer();
    return pdfjsLib.getDocument({ data }).promise;
}
